<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-layout row wrap>
      <v-overlay :value="pageLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex v-if="!pageLoading">
        <filter-revenue
          :default-search-params="searchParams"
          :is-component-loading="isRequestingNow"
          @filtering="onFilter"
        ></filter-revenue>

        <div v-if="paginatedObject.data && paginatedObject.data.length" class="my-3">
          <v-container>
            <v-layout class="overflow-x-hidden px-3">
              <div class="responsiveTable">
                <table class="tableRevenueItems">
                  <tr>
                    <th>ID</th>
                    <th>{{ $t('general.region') }}</th>
                    <th>{{ $t('table.headers.date') }}</th>
                    <th>{{ $t('general.category') }}</th>
                    <th>{{ $t('table.headers.type') }}</th>
                    <th>{{ $t('table.headers.sum') }}</th>
                    <th>{{ $t('general.actions') }}</th>
                  </tr>
                  <tr :key="revenueItem.uuid" v-for="(revenueItem,index) in paginatedObject.data">
                    <td>{{ index + 1 }}</td>
                    <td>{{ $t('enums.region.' + revenueItem.region) }}</td>
                    <td>{{ moment(revenueItem.accounting_date).format(DATE_VIEW) }}</td>
                    <td>{{ $t(`enums.order_category_types.${revenueItem.order_category}`) }}</td>
                    <td>{{ getType(revenueItem)  }}</td>
                    <td>{{ (revenueItem.amount).toFixed(2) }}</td>
                    <td>
                      <div class="d-flex justify-md-center justify-space-between">
                        <v-btn
                          color="blue"
                          class="ml-2"
                          dark
                          fab
                          x-small
                          @click="$router.push({
                            name: 'revenue.show',
                            params: { uuid: revenueItem.uuid },
                            });"
                        >
                          <v-icon>mdi-eye</v-icon>
                        </v-btn>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </v-layout>
          </v-container>
        </div>
        <pagination-listing
          :pagination-data="paginationData"
          @go-prev="changePage('-')"
          @go-next="changePage('+')"
        ></pagination-listing>
      </v-flex>
      <modal-loading :is-show="isTableLoading"></modal-loading>
      <v-btn
        color="pink"
        dark
        fixed
        bottom
        right
        fab
        @click="$router.push({
          name: 'revenue-items.create',
          });"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import i18n from '@/i18n';
import moment from 'moment';
import paginationMixin from '@/mixins/listing/paginationMixin';
import updatePageContentMixin from '@/mixins/updatePageContentMixin';
import defaultListingMixin from '@/mixins/listing/defaultListingMixin';
import ModalLoading from '@/components/loaders/ModalLoading.vue';
import FilterRevenue from '@/components/listings/FilterRevenue';
import PaginationListing from '@/components/listings/PaginationListing.vue';
import { PER_PAGE_ORDERS } from '@/constants/listing';
import { DATE_VIEW } from '@/constants/dates';
import { deepMerge } from '@/utils';
import RevenueProxy from '@/proxies/Revenue/RevenueProxy';
import EditModalStockIncome from '@/components/listings/EditModalStockIncome.vue';

export default {
  name: 'RevenueListing',
  mixins: [
    paginationMixin,
    updatePageContentMixin,
    defaultListingMixin,
  ],
  components: {
    FilterRevenue,
    ModalLoading,
    PaginationListing,
    EditModalStockIncome,
  },
  data() {
    return {
      moment,
      DATE_VIEW,
      currentStockItem: {},
      currentEditableItem: {},
      isShowIncomeDialog: false,
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        page: {
          number: 1,
          size: PER_PAGE_ORDERS,
        },
        from: null,
        region: null,
      },
    };
  },
  created() {
    this.isTableLoading = true;
  },
  methods: {
    fetchData() {
      this.isRequestingNow = true;
      new RevenueProxy()
        .setParameters(this.searchParams)
        .all()
        .then((response) => {
          this.paginatedObject = response.data.data.revenue;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.warn(error);
          this.paginatedObject = {};
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    onFilter(event) {
      const newSearchParams = Object.assign({}, event);
      this.searchParams = deepMerge(this.searchParams, deepMerge(newSearchParams, {
        page: {
          number: 1,
        },
      }));
    },
    onCloseDialog(item) {
      this.isShowIncomeDialog = false;
    },
    onActionDialog(item) {
      this.fetchData();
      this.onCloseDialog();
    },
    getType(item) {
      let type = '';
      if (item.order_category === 'base') {
        type = `${this.lang(this.$store, `sap/listings.global.filter.order_base_types.${item.order_type}`)}`;
      }
      if (item.order_category === 'complex') {
        type = `${this.lang(this.$store, `sap/listings.global.filter.order_complex_types.${item.order_type}`)}`;
      }
      return type;
    },
  },
};
</script>

<style scoped lang="scss">
.tableRevenueItems {
  width: 100%;
  border-spacing: 0;

  th {
    border: 1px solid #dddddd;
  }

  td {
    border: 1px solid #dddddd;
    padding: 0 8px;
  }
}
.responsiveTable {
  overflow-x: auto;
  width: 100%;
}
</style>
